import { createContext,useContext } from 'react';
import { SiteVariantType,type SiteVariantConfig } from '../config/siteVariants';

export interface SiteVariantContextType {
    variant: SiteVariantType;
    config: SiteVariantConfig;
    isMain: boolean;
}

export const SiteVariantContext = createContext<SiteVariantContextType | undefined>(undefined);

export const useSiteVariant = () => {
    const context = useContext(SiteVariantContext);
    if (context === undefined) {
        throw new Error('useSiteVariant must be used within a SiteVariantProvider');
    }
    return context;
};
